import { PenNib, MagnifyingGlass, Handshake } from '@phosphor-icons/react';

// Inline onboarding guidance shown under the timeline on a My Matters card for matters
// still in the Onboarding phase. Mirrors the Search Completed card's structure (a short
// header + intro line + a 2x2 tile grid) so the two stages feel visually consistent.
export function OnboardingInline({ matter }) {
  const tiles = [
    {
      icon: PenNib, accent: '#ffd100', label: 'Engagement letter',
      body: "If you haven't already, sign the engagement letter we sent via Dropbox Sign so we can officially get to work on your mark.",
    },
    {
      icon: MagnifyingGlass, accent: '#141b4d', label: 'What happens next',
      body: 'We run your full search, then send your plain-English TM search report (usually 1–2 weeks) with our recommendation.',
    },
    {
      icon: Handshake, accent: '#141b4d', label: "You're in good hands",
      body: "All signed? Perfect — nothing else is needed right now. We'll track every step and keep you posted the whole way.",
    },
  ];

  return (
    <div className="mt-4 pt-4" style={{ borderTop: '1px solid #ece5d8' }} data-testid={`onboarding-inline-${matter.id}`}>
      {/* Header + stage badge */}
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <h4 className="text-sm font-bold uppercase tracking-wide" style={{ color: '#1d57a5' }}>You're onboarded — here's where things stand</h4>
        <span className="text-xs font-bold px-2 py-1" style={{ backgroundColor: '#ffd100', color: '#141b4d' }}>Getting started</span>
      </div>

      {/* Intro line */}
      <p className="text-xs mb-4 leading-relaxed" style={{ color: '#9a9488' }}>
        You're at the very start of the journey. One quick thing to check off, then we take it from here — you don't have to decode the USPTO alone.
      </p>

      {/* 2x2 tile grid */}
      <div className="grid sm:grid-cols-2 gap-3">
        {tiles.map((t, i) => {
          const Icon = t.icon;
          return (
            <div key={i} className="p-4 h-full" style={{ backgroundColor: '#ffffff', border: '1px solid #ece5d8', borderTop: `3px solid ${t.accent}` }}
              data-testid={`onboarding-tile-${matter.id}-${i}`}>
              <div className="flex items-center gap-1.5 mb-2">
                <Icon weight="fill" className="w-4 h-4" style={{ color: t.accent === '#ffd100' ? '#c99a00' : '#1d57a5' }} />
                <span className="text-[11px] font-bold uppercase tracking-wide" style={{ color: '#141b4d' }}>{t.label}</span>
              </div>
              <p className="text-sm leading-relaxed" style={{ color: '#101820' }}>{t.body}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
